module.exports = __webpack_public_path__ + "static/media/WK.69bfe0a4.PNG";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/WK.PNG
// module id = 1652
// module chunks = 1